import { SocketMessageType } from '@/constants/socketMessages';

export const DEFAULT_COLOR = '#DEE5F1';

export const PROJECT_DUE_DATE_VALIDATION_FIELD = 'dueDate';

export const SOCKET_MESSAGES_THAT_TRIGGER_REFETCHING = [
	SocketMessageType.TIME_ENTRY_CREATED,
	SocketMessageType.TIME_ENTRY_DELETED,
	SocketMessageType.TIME_ENTRY_UPDATED,
	SocketMessageType.TASK_CREATED,
	SocketMessageType.TASK_UPDATED,
	SocketMessageType.TASK_SET_DONE,
	SocketMessageType.EVENT_CREATED,
	SocketMessageType.EVENT_UPDATED,
	SocketMessageType.EVENT_DELETED,
	SocketMessageType.PROJECT_TIMEFRAME_CHANGED,
	SocketMessageType.PROJECT_CHANGED,
];

export const PROJECT_REFETCH_DEBOUNCE_MS = 1000;

export const PROJECT_INDICATOR_TYPE = {
	PERSONAL: 'personal',
	MEMBERS_ONLY: 'members_only',
	INTERNAL: 'internal',
};
